import { Box, Stack, Typography } from '@mui/material'
import SectionContainer from './SectionContainer'
import { SectionTemplate } from '../types'
import { PATH_COLORS } from '../palette'

interface Action {
  title?: string
  body?: string
}

interface Props {
  template: SectionTemplate
  values: { actions?: Action[] }
  title: string
  description: string
  sectionNumber?: number
}

// Slightly larger palette so 4+ action cards don't repeat colors immediately
const ACTION_PALETTE = [
  PATH_COLORS[0],
  PATH_COLORS[1],
  PATH_COLORS[2],
  '#aa5a5a',
]

export default function ActionCardsSection({ template, values, title, description, sectionNumber }: Props) {
  const actions = values?.actions || []

  return (
    <SectionContainer
      id={template.sectionTypeId}
      number={sectionNumber}
      title={title}
      description={description}
    >
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: 'repeat(2, 1fr)' },
          gap: 3,
        }}
      >
        {actions.map((action, i) => {
          const accent = ACTION_PALETTE[i % ACTION_PALETTE.length]
          return (
            <Box
              key={i}
              sx={{
                position: 'relative',
                p: 3,
                pl: 4,
                background: 'rgba(255,255,255,0.75)',
                borderTop: 1,
                borderRight: 1,
                borderBottom: 1,
                borderColor: 'divider',
                '&::before': {
                  content: '""',
                  position: 'absolute',
                  left: 0,
                  top: 0,
                  bottom: 0,
                  width: 4,
                  background: accent,
                },
              }}
            >
              <Stack spacing={1.5}>
                <Stack direction="row" alignItems="center" spacing={1}>
                  <Box
                    sx={{
                      width: 24,
                      height: 24,
                      borderRadius: '50%',
                      background: accent,
                      color: 'white',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontFamily: 'var(--ns-display-font)',
                      fontWeight: 600,
                      fontSize: 12,
                    }}
                  >
                    {i + 1}
                  </Box>
                  <Typography
                    variant="overline"
                    sx={{ color: accent, letterSpacing: 2, fontWeight: 700, fontSize: 10 }}
                  >
                    Action
                  </Typography>
                </Stack>
                <Typography
                  sx={{
                    fontFamily: 'var(--ns-display-font)',
                    fontSize: 22,
                    fontWeight: 500,
                    lineHeight: 1.2,
                  }}
                >
                  {action.title}
                </Typography>
                {action.body && (
                  <Typography variant="body2" sx={{ lineHeight: 1.6 }}>
                    {action.body}
                  </Typography>
                )}
              </Stack>
            </Box>
          )
        })}
      </Box>
    </SectionContainer>
  )
}
